export function validateAttributes(attributes) {
    return Object.keys(attributes).filter(
        key => !isAttributeValid(attributes[key])
    );
}

export function isAttributeValid(attribute) {
    return (attribute !== undefined) && (attribute !== null) && (attribute.trim().length !== 0);
}




/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/validations.js
 **/